import { render, staticRenderFns } from "./DashFunnel.vue?vue&type=template&id=9ddd0ac8&scoped=true"
import script from "./DashFunnel.vue?vue&type=script&lang=js"
export * from "./DashFunnel.vue?vue&type=script&lang=js"
import style0 from "./DashFunnel.vue?vue&type=style&index=0&id=9ddd0ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddd0ac8",
  null
  
)

export default component.exports